import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
	selector: 'uc-clearing-toggle',
	imports: [NgClass],
	templateUrl: './clearing-toggle.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearingToggleComponent {
	isClearing = input.required<boolean>();
	customStyles = input('text-white');

	changeChecked = output<boolean>();

	updateValue(event: Event): void {
		const target = event.target as HTMLInputElement;
		const value = target.checked;
		this.changeChecked.emit(value);
	}
}
